<template>
    <div class="Login">
        <form @submit.prevent="login">
            <input-field
                v-model="form.email"
                :validations="$v.form.email"
                :definition="{
                    id: 'email',
                    label: 'Email*',
                }"
                v-on:bluremail="validateInput($v.form.email)">
            </input-field>

            <transition name="slide-fade">
                <div class="Form-inputError" v-if="$v.form.email.$error && !$v.form.email.required">Email is required</div>
            </transition>

            <input-field
                v-model="form.password"
                :validations="$v.form.password"
                :definition="{
                    id: 'password',
                    label: 'Password*',
                    fieldType: 'password',
                }"
                v-on:blurpassword="validateInput($v.form.password)">
            </input-field>

            <transition name="slide-fade">
                <div class="Form-inputError" v-if="$v.form.password.$error && !$v.form.password.required">Password is required</div>
            </transition>
            <button
                class="Button"
                @click="login"
                :disabled="asyncInProgress || disableForm">Log in</button>
        </form>
        <error v-if="asyncFormError" :message="errorMessage"></error>
    </div>
</template>

<script>
import { required} from 'vuelidate/lib/validators'
import InputField from './input-field/input-field.vue';
import cookieModel from '../models/cookie';
import loginModel from '../models/login';
import errorModel from '../models/error';
import { eventBus } from "../models/events";
import axios from "axios";

export default {
    components: {
        InputField,
    },
    mounted() {
        this.init();
    },
    props: {
    },
    methods: {
        init: function() {
            let vm = this;

            if (sessionStorage.getItem(errorModel.SESSION_INVALIDATED_KEY)) {
                sessionStorage.removeItem(errorModel.SESSION_INVALIDATED_KEY);
                return;
            }

            if (loginModel.isLoggedIn()) {
                vm.$router.push({
                    name: 'Dashboard',
                    params: {}
                });
            }
        },
        login: function() {
            let vm = this;
            let url = vm.baseUrl + "/login";
            let postData = {};

            postData['email'] = vm.form.email;
            postData['password'] = vm.form.password;
            postData['grant_type'] = 'password';
            postData['client_id'] = process.env.VUE_APP_CLIENT_ID;
            postData['client_secret'] = process.env.VUE_APP_CLIENT_SECRET;
            postData['username'] = vm.form.email;

            if (vm.asyncInProgress) {
                return;
            }

            vm.asyncInProgress = true;
            vm.disableForm = true;

            // Send data from this registration step to API
            vm.axiosInstance.post(url, postData)
                .then(function(response) {
                    if (response.data) {
                        // reset error
                        vm.asyncFormError = false;

                        if(response.data.status === "error"){
                            vm.asyncFormError = true;
                            vm.errorMessage = response.data.message;
                        } else {
                            sessionStorage.removeItem(errorModel.SESSION_INVALIDATED_KEY);
                            cookieModel.setCookie('ticketlab_access', response.data.access_token);
                            eventBus.$emit('loggedIn', true);

                            if (window.gtag) {
                                let analyticsAction = 'login';
                                let analyticsEventObject = {
                                    event_category: 'engagement',
                                    event_label: 'Logged in'
                                };

                                window.gtag('event', analyticsAction, analyticsEventObject);
                            }

                          // if router isn't on Dashboard, send to dashboard
                          if (vm.$route.name !== 'Dashboard') {
                            vm.$router.push({
                              name: 'Dashboard',
                              params: {}
                            });
                          }

                          vm.disableForm = false;
                        }
                    }
                }).catch(function(error) {
                    let response = error.response;
                    vm.errorMessage = 'Error contacting server. Please try again later.';

                    if (response !== undefined && response.status === 400) {
                        if (response.data.message !== undefined) {
                            vm.errorMessage = response.data.message;
                        }
                    }
                    vm.asyncFormError = true;
                    vm.disableForm = false;
                    vm.asyncInProgress = false;

                });
        },
        validateInput: function(subject) {
            subject.$touch();
        },
    },
    validations: {
        form: {
            email: {
                required
            },
            password: {
                required
            }
        }
    },
    data: function () {
        return {
            baseUrl: process.env.VUE_APP_API_URL,
            venueId: process.env.VUE_APP_VENUE_ID,
            axiosInstance: axios.create({
                baseURL: this.baseUrl,
            }),
            asyncInProgress: false,
            asyncFormError: false,
            disableForm: false,
            errorMessage: '',
            form: {
                email: '',
                password: '',
            }
        }
    }
}
</script>
